module.exports = __webpack_public_path__ + "favicon-32x32.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./src/favicon-32x32.png
// module id = 144
// module chunks = 0